import {
  TankQuickFilterModel,
} from '../../modules/tank-quick-filters/components/global-tank-filters/tank-quick-filters.component';
import { Action } from '@ngrx/store';
import { ITankProfile } from 'src/app/interfaces/tankProfile';
import { ITankViewProfileSimple } from '../../interfaces/tankViewProfile';
import { IUserInformation } from '../../interfaces/userInformation';

export const GET_USER_INFO = '[USER] GetUserInfo';
export const SET_LAST_SELECTED_ORGANIZATION =
  '[User] SetLastSelectedOrganization';
export const SET_LAST_SELECTED_TVP = '[User] SetLastSelectedTvp';
export const GET_PARENT_ORGANIZATION_TREE = '[User] GetParentOrganizationTree';
export const SET_LAST_SELECTED_TANK_PROFILE =
  '[User] SetLastSelectedTankProfile';

export const SET_LAST_SELECTED_TANK_QUICK_FILTER =
  '[User] SetLastSelectedTankFilter';
export const SET_USER_INFO = '[User] SetUserInfo';

export class GetUserInfo implements Action {
  readonly type = GET_USER_INFO;

  constructor(public userInformation: IUserInformation) {}
}

export class SetUserInfo implements Action {
  readonly type = SET_USER_INFO;
  constructor(public userInformation: IUserInformation) {}
}

export class SetLastSelectedOrganization implements Action {
  readonly type = SET_LAST_SELECTED_ORGANIZATION;

  constructor(public org: { orgId: number; orgName: string }) {}
}

export class SetLastSelectedTvp implements Action {
  readonly type = SET_LAST_SELECTED_TVP;

  constructor(public tvp: ITankViewProfileSimple) {}
}

export class SetLastSelectedTankProfile implements Action {
  readonly type = SET_LAST_SELECTED_TANK_PROFILE;

  constructor(public tankProfile: ITankProfile) {}
}

export class GetParentOrganizationTree implements Action {
  readonly type = GET_PARENT_ORGANIZATION_TREE;

  constructor(public parentOrgTree: any[]) {}
}

export class SetLastSelectedTankQuickFilter implements Action {
  readonly type = SET_LAST_SELECTED_TANK_QUICK_FILTER;

  constructor(public tankQuickFilter: TankQuickFilterModel) {}
}


export type Actions =
  | GetUserInfo
  | SetLastSelectedOrganization
  | SetLastSelectedTvp
  | GetParentOrganizationTree
  | SetLastSelectedTankProfile
  | SetLastSelectedTankQuickFilter
  | SetUserInfo;
